import { render, staticRenderFns } from "./SocLogin.vue?vue&type=template&id=49a02f53"
import script from "./SocLogin.vue?vue&type=script&lang=js"
export * from "./SocLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports